import { extractDateTimeStamp } from '../utils/date-timestamp-extraction';
import { AanlgesiaTagTypeType, AnalgesiaTagLocationType } from '../types';

export const TAG_CATEGORIES = ['flexion', 'surface', 'analgesia'] as const;
export type TagCategory = (typeof TAG_CATEGORIES)[number];

export interface Tag {
  id: string;
  category: TagCategory;
}

export class TagClass implements Tag {
  id: string;
  category: TagCategory;

  constructor(o: any = {}) {
    this.id = o['id'];
    this.category = o['category'];
  }
}

export interface BaseTag extends Tag {
  name: string;
  abbreviation: string;
  isActive: boolean;
  dateAdded: Date | null;
  index: number;
}

export class BaseTagClass extends TagClass implements BaseTag {
  name: string;
  abbreviation: string;
  isActive: boolean;
  dateAdded: Date | null;
  index: number;

  constructor(o: any = {}) {
    super(o);
    this.name = o['name'];
    this.abbreviation = o['abbreviation'];
    this.isActive = o['isActive'];
    this.dateAdded = extractDateTimeStamp(o['dateAdded']);
    this.index = o['index'];
  }
}

export interface AnalgesiaTag extends BaseTag {
  location: AnalgesiaTagLocationType;
  type: AanlgesiaTagTypeType;
}

export class AnalgesiaTagClass extends BaseTagClass implements AnalgesiaTag {
  location: AnalgesiaTagLocationType;
  type: AanlgesiaTagTypeType;

  constructor(o: any = {}) {
    super(o);
    this.location = o['location'];
    this.type = o['type'];
  }
}

export interface FlexionTag extends BaseTag {
  limb: string;
}

export class FlexionTagClass extends BaseTagClass implements FlexionTag {
  limb: string;

  constructor(o: any = {}) {
    super(o);
    this.limb = o['limb'];
  }
}

export type SurfaceTagType = 'hard' | 'soft';

export interface SurfaceTag extends BaseTag {
  type: SurfaceTagType;
  // Not read/written anywhere yet — will be used in the future.
  functionalProperties: string[];
}

export class SurfaceTagClass extends BaseTagClass implements SurfaceTag {
  type: SurfaceTagType;
  functionalProperties: string[];

  constructor(o: any = {}) {
    super(o);
    this.type = o['type'];
    this.functionalProperties = o['functionalProperties'] ?? [];
  }
}

